var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "date",
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08 3.31V0.93C4.08 0.42 4.5 0 5.01 0C5.52 0 5.94 0.42 5.94 0.93V3.31C5.94 3.82 5.52 4.24 5.01 4.24C4.5 4.23 4.08 3.82 4.08 3.31ZM12.07 4.23C12.58 4.23 13 3.81 13 3.3V0.93C13 0.42 12.58 0 12.07 0C11.56 0 11.14 0.42 11.14 0.93V3.31C11.14 3.82 11.56 4.23 12.07 4.23ZM17.08 2.11V14.67C17.08 15.08 16.75 15.41 16.34 15.41H0.74C0.33 15.41 0 15.08 0 14.67V2.11C0 1.7 0.33 1.3 0.74 1.3H2.48C2.89 1.3 3.22 1.63 3.22 2.04C3.22 2.45 2.89 2.78 2.48 2.78H1.49V5.94H15.6V2.78H14.6C14.19 2.78 13.86 2.45 13.86 2.04C13.86 1.63 14.19 1.3 14.6 1.3H16.34C16.75 1.3 17.08 1.7 17.08 2.11ZM15.6 13.93V7.24H1.49V13.92H15.6V13.93ZM7.37 2.78H9.71C10.12 2.78 10.45 2.45 10.45 2.04C10.45 1.63 10.12 1.3 9.71 1.3H7.37C6.96 1.3 6.63 1.63 6.63 2.04C6.63 2.45 6.96 2.78 7.37 2.78Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.b132683ab83fce9ddcb91b6ab8d6b579.svg";
export { ForwardRef as ReactComponent };